var page = page || {};

page.home = (function ($) {

	matchHeights = function() {
		$('.home__latest').matchHeight();
		$('.home__imglinks .imglink__row').matchHeight();		
	}, 



    init = function () {
    	matchHeights();
    };

    return {
        init: init
    }    	

}( jQuery, this ));

jQuery(page.home.init);